import React, { useMemo } from 'react';
import MagicForm from '../../../../Components/Form/MagicForm';
import { discourseTravelFormScheme } from './discourseTravelFormScheme';
import { getDefaultData } from '../../../MagicForm/Services/magicForm-defaultsData.service';
import { useAppContext } from '../../../../Services/AppContext';
import {
	usePatientInformationQuery,
	useWorkplaceBasicDataQuery,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import {
	DiscourseTravelFormValues,
	mapAddressToDiscourseTravelAddress,
} from './discourseTravel.helpers';

interface Props {
	patientId: string;
	existingValues?: DiscourseTravelFormValues;
	onSubmit: (values: DiscourseTravelFormValues) => Promise<void>;
	disableSubmit?: boolean;
}

const DiscourseTravelForm = ({
	patientId,
	existingValues,
	onSubmit,
	disableSubmit = false,
}: Props) => {
	const { workplaceId } = useAppContext();
	const { data: workplaceData, isLoading: isWorkplaceLoading } =
		useWorkplaceBasicDataQuery({ id: workplaceId });
	const { data: patientData, isLoading: isPatientLoading } =
		usePatientInformationQuery({ userId: patientId });

	const defaultValues = useMemo(() => {
		if (existingValues) {
			return existingValues;
		}

		const baseValues = getDefaultData({ data: discourseTravelFormScheme });

		return {
			...baseValues,
			fromAddress: mapAddressToDiscourseTravelAddress(
				workplaceData?.workplace?.address,
			),
			toAddress: mapAddressToDiscourseTravelAddress(
				patientData?.user?.profile?.address,
			),
		};
	}, [
		existingValues,
		workplaceData?.workplace?.address,
		patientData?.user?.profile?.address,
	]);

	const handleSubmit = async (values: DiscourseTravelFormValues) => {
		await onSubmit(values);
	};

	if (!existingValues && (isWorkplaceLoading || isPatientLoading)) {
		return <Loading />;
	}

	return (
		<MagicForm
			formScheme={discourseTravelFormScheme}
			defaultValues={defaultValues}
			onSubmit={handleSubmit}
			disableSubmit={disableSubmit}
		/>
	);
};

export default DiscourseTravelForm;
